import type { IStatusProps } from 'shared/ui/Status'
import type { ITriggerStatus } from 'entities/Trigger/api/type'

const DEFAULT_CONFIG: IStatusProps = {
  title: 'Active',
  icon: 'check2',
  emphasis: 'high',
  intent: 'positive',
}
const ACTIVE_CONFIG: IStatusProps = {
  title: 'Active',
  icon: 'check2',
  emphasis: 'high',
  intent: 'positive',
}

const DISABLED_CONFIG: IStatusProps = {
  title: 'Disabled',
  icon: 'minusCircle',
  emphasis: 'high',
  intent: 'neutral',
}

const INVALID_CONFIG: IStatusProps = {
  title: 'Invalid',
  icon: 'closeCircle',
  emphasis: 'high',
  intent: 'negative',
}

export const getConfigByStatus = (status?: ITriggerStatus) => {
  switch (status) {
    case 'active':
      return ACTIVE_CONFIG
    case 'disabled':
      return DISABLED_CONFIG
    case 'invalid':
      return INVALID_CONFIG
    default:
      return DEFAULT_CONFIG
  }
}
